import { Component, Inject,Input , Output, ViewChild, OnInit, OnDestroy, NgZone } from '@angular/core';
import vegaEmbed, {Result as VegaEmbedResult, EmbedOptions } from 'vega-embed';
// import vegaEmbed from 'vega-embed';
// import type { EmbedOptions, Result as VegaEmbedResult } from 'vega-embed';
import _ from 'lodash';
import {moment} from '../../../js/globals';
import { ClientLoggerService } from '../../services/client-logger.service';

import { MySynchConstantService } from '../../services/mysynch.constant.service';
import { PerformanceMetricsService } from '../../services/performance-metrics.service';
import { MySynchEnumerationService } from "../../services/mysynch.enumeration.service";
import { PerformanceContextService } from '../../services/performance-context.service';
import { PerformanceContext} from '../../interfaces/mysynch.interfaces';
import { DeviceDetectorService } from "ngx-device-detector";
import { Herd } from '../../interfaces/mysynch.interfaces';
import { MySynchDataStore } from '../../data-stores/mysynch.datastore';
import { Config, Renderers } from 'vega';
@Component({
  standalone: false,
  selector: 'trends-and-targets',
  templateUrl: '../app/pages/trends-and-targets/trends-and-targets.view.html',
  styleUrls:['../app/pages/trends-and-targets/trends-and-targets.style.css']
})
export class TrendsAndTargets implements OnInit , OnDestroy {

    private performanceContext: PerformanceContext | null = null;
	private showVegaEditor: boolean = true;
    private envName:string = "";
    private pythonServicesFunctionUrl:string = "";
    private pageViewBetaReq:string[] = ["TnT"];
    private currentActiveHerd:Herd = null;
	private currentActiveFarm:any = null;
	private herdId:number = null;
	private minChartDate: moment.Moment = null;
    private maxChartDate: moment.Moment = null;

	private originalPythonSpecWithData: any = {};
	private chartSpec_lg: any = {};
	private chartSpec_sm: any = {};
	// --- Each data set ---
	private dataLact1: any = {};
	private dataLact2: any = {};
	private dataLactAll: any = {};
	private chartWidth_lg: number = 1000;
	private chartWidth_sm: number = 180;
	// chart views
	private currentLargeChartView: any =  {};
	private sm_chart_lactation_all_view: any = {};
	private sm_chart_lactation1_view: any = {};
	private sm_chart_lactation2_view: any = {};
	private dt: string = "";
	private dataUpdatedDate: string = "";
	
	private journalUpdatePermissionCode:string = 'JOURNAL_UPDATE';
	private journalData: any[] = [];
	private filteredJournalGridData: any[] = [];
	private journalItems: any[] = [];
	private ymd: string          = 'YYYY-MM-DD'; // Used for ordering
	private dateFormat: string   = "";
	private journalFlagColor: string         = 'rgba(78,78,78, 0.9)';
	private journalHoverflagColor: string    = 'rgba(36,47,255, 0.9)';
	private noteIcon: any[]          = new Array(10);
	private noteHoverIcon: any[]     = new Array(10);
	private journalCategories: string[] = [];
	
	
	private herdChangeSubscription: any;
	

    
    loading: boolean = false;
	isMobile: boolean = false;
    reportLoading: boolean = false;
    canViewPage: boolean = true;
	territoryManager:any = null;
	hasJournalUpdatePermission  = false;
	selectedJournals: any[] = [];
	showingJEs: boolean = false;
	// -- TODO: Get this all from dbo.CodeFile ---
	fertilityRateItems: any[] = [
		{ code: 'PregRate',   name: 'Pregnancy Risk (21 day)',    rhaname: 'RhaPreg' },
		{ code: 'InsemRate',  name: 'Insemination Risk (21 day)', rhaname: 'RhaInsem' },
		{ code: 'ConcepRate', name: 'Conception Risk (21 day)',   rhaname: 'RhaConcep' }
	];
	// -- TODO: Get this all from dbo.CodeFile ---
	fertilityRhaRateItems: any[] = [
		{ code: 'PregRate',   rhaname: 'RhaPreg'    },
		{ code: 'InsemRate',  rhaname: 'RhaInsem'   },
		{ code: 'ConcepRate', rhaname: 'RhaConcep'  },
		{ code: 'RhaPreg',    rhaname: 'RhaPreg'    },
		{ code: 'RhaInsem',   rhaname: 'RhaInsem'   },
		{ code: 'RhaConcep',  rhaname: 'RhaConcep'  }
	];
			
	//opt: any    = {};
	opt: any    = {
		fertilityRateSelected: 'PregRate',
		fertilityRhaRateSelected: 'RhaPreg',
		show21dayDots: true,
		showStdErrorShade: false,
		showRhaLine: false,
		showNewYear: true,
		showTargetValue: false,
		showJournalEntries: true,
		trendSensitivity: "0.30",
		lactSelected: 3,
		lactSelectedDesc: 'All Lactations'
	};
	// --- new Options Menu click handler ---
	optionsMenuOpen: boolean = false;


    constructor(@Inject('MySynchFactory') private MSF:any,
                @Inject('ApiFactory') private api:any,
                @Inject('ViewAuthorizationFactory') private viewAuth:any,
				@Inject(NgZone) private ngZone:NgZone,
				@Inject(MySynchDataStore) private mysynchDataStore:MySynchDataStore,
                @Inject(MySynchConstantService) private mySynchConstantService:MySynchConstantService, 
                @Inject(MySynchEnumerationService) private mySynchEnumSvc:MySynchEnumerationService,
                @Inject(PerformanceMetricsService) private perfMetricSvc:PerformanceMetricsService,
				@Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService,
				@Inject(DeviceDetectorService) private deviceDetectorSvc:DeviceDetectorService,
                @Inject(ClientLoggerService) private log:ClientLoggerService
            ) {
				this.isMobile = this.deviceDetectorSvc.isMobile();
           }

        ngOnInit() {
			this.loading = true;

			// --- Initialize Journal Note Icons ---
			this.createJournalNoteIcons();

			this.MSF.ready(() => {
			   
			  this.envName = this.MSF.getEnvironmentName();
              this.currentActiveHerd = this.MSF.getActiveHerd();
              this.currentActiveFarm = this.MSF.getActiveFarm();
              this.territoryManager  = this.MSF.getActiveFarmTerritoryManager();
			  this.journalCategories = this.MSF.lists.journalCategory;
			  
			  this.dateFormat = this.MSF.getActiveHerdTimeFormatWithLongDigitYear();

              this.herdId = _.get(this.currentActiveHerd,'herdId',_.get(this.currentActiveFarm,'herds[0].herdId'));
              this.setPythonFunctionUrl();

			  this.dt = this.MSF.activeHerd.latestReportDate;
			  this.dataUpdatedDate = moment(this.dt).subtract(moment(this.dt).utcOffset(), 'minutes').format(this.MSF.i18n.format.dateLong);

			  this.checkPermissions();

              if (this.canViewPage == true) {
               
				   this.performanceContext = this.perfContextSvc.createPerformanceContext(this.herdId);
				   this.perfMetricSvc.startTiming('Page:ThreeYearTrends:Render');
				   this.loadReports().then((result)=>{
                            this.perfMetricSvc.markPageReady('Page:ThreeYearTrends:Render', this.performanceContext);
				   });
              };

			  this.herdChangeSubscription = this.mysynchDataStore.currentActiveHerd
				.subscribe((herd)=>{
					if(!_.isUndefined(herd) && this.loading === false){
						this.loading = true;
                
						this.currentActiveHerd = this.MSF.getActiveHerd();
						this.currentActiveFarm = this.MSF.getActiveFarm();
						this.territoryManager  = this.MSF.getActiveFarmTerritoryManager(); 

						const dt = this.MSF.activeHerd.latestReportDate;
						this.dataUpdatedDate = moment(dt).subtract(moment(dt).utcOffset(), 'minutes').format(this.MSF.i18n.format.dateLong);

						this.herdId = _.get(this.currentActiveHerd,'herdId',_.get(this.currentActiveFarm,'herds[0].herdId'));

						this.setPythonFunctionUrl();
						this.checkPermissions();

						if (this.canViewPage == true) {
							this.performanceContext = this.perfContextSvc.createPerformanceContext(this.herdId);
							this.perfMetricSvc.startTiming('Page:ThreeYearTrends:RenderOnHerdChange');
							this.loadReports().then((result)=>{
								this.perfMetricSvc.markPageReady('Page:ThreeYearTrends:RenderOnHerdChange', this.performanceContext); 
							});
						};              
						
						this.closeJEs(); // Close Journal Entries panel if open
					}
				}); 
              
              // --- Options Menu to Stay Open instead of Dropdown's natural behavior, but Close when click outside of the Dropdown area ---
			  this.MSF.waitForElm('.trends-and-targets-options-menu.dropdown-toggle').then(() => {
				  var optionsToggleElm = $(".trends-and-targets-options-menu.dropdown-toggle").get(0);    
             
                  if(!_.isUndefined(optionsToggleElm)){
					  $('.trends-and-targets-options-menu.dropdown-toggle').on('click',function (event) {
						console.log("opening tnt menu from TNT ")
						$('.trends-and-targets-options-menu-container.dropdown').toggleClass('open');
					  });
				  }
			 });
             
 
              $('body').on('click', (event:any) => {
                  if (  !$('li.dropdown.trends-and-targets-options-menu-container').is(event.target)
                      && $('li.dropdown.trends-and-targets-options-menu-container').has(event.target).length === 0
                      && $('.open').has(event.target).length === 0
                  ) {
                    console.log("closing tnt menu from TNT ")
                        $('.trends-and-targets-options-menu-container.dropdown').removeClass('open');
                    }
                });
           
        });
            
        
        }
        ngOnDestroy() {
			 if(this.herdChangeSubscription){
            	this.herdChangeSubscription.unsubscribe();
			 }

			 this.performanceContext = null;

			// unregister body click handler
			$('body').off('click');
		
			// unregister journal signal listener
			if (this.currentLargeChartView) {
				this.currentLargeChartView.removeSignalListener('journal_icon_click', this.journalSignalListener);
			}

			// clean up options menu click handler
				$('.trends-and-targets-options-menu.dropdown-toggle').off('click');

				
				 // Clean up all Vega views using the helper function
				this.cleanupVegaView(this.sm_chart_lactation1_view, '#visLact1');
				this.cleanupVegaView(this.sm_chart_lactation2_view, '#visLact2');
				this.cleanupVegaView(this.sm_chart_lactation_all_view, '#visLactAll'); // Note: fixed variable name
				this.cleanupVegaView(this.currentLargeChartView, '#visSelected');

				//['visSelected', 'visLactAll', 'visLact1', 'visLact2'].forEach(nukeChartContainer);

				// Null out all view references
				this.sm_chart_lactation1_view = null;
				this.sm_chart_lactation2_view = null;
				this.sm_chart_lactation_all_view = null;
				this.currentLargeChartView = null;

				// Clean up data references
				this.chartSpec_lg = null;
				this.chartSpec_sm = null;
				this.dataLact1 = null;
				this.dataLact2 = null;
				this.dataLactAll = null;
				this.originalPythonSpecWithData = null;	
        }
            		
		private createJournalNoteIcons(): void {
			for (var i1 = 0; i1 <= 9; i1++) {
				this.noteIcon[i1]           = new Image();
				this.noteIcon[i1].src       = '/img/journal-icons/NoteGray' + i1 + '.png';
				this.noteHoverIcon[i1]      = new Image();
				this.noteHoverIcon[i1].src  = '/img/journal-icons/NoteBlue' + i1 + '.png';
				// -- resize images
				this.noteIcon[i1].style.width   = '20%';
				this.noteIcon[i1].style.height  = 'auto';
			}
		}

		private setPythonFunctionUrl() {
			switch (this.envName) {
				case "PROD":
					this.pythonServicesFunctionUrl = "https://mysynchpythonservices-functionprod.azurewebsites.net/api/TrendsAndTargets?code=od3EFBmOYwbjz8RM0nRYt5s0Fzfqw-WNhe3PmWQ8p-ovAzFufcnjSQ==";
					break;
				case "STAGE":
					this.pythonServicesFunctionUrl = "https://mysynchpythonservices-functionstage.azurewebsites.net/api/TrendsAndTargets?code=sp6UN6KBWlvDXd-RjurwTjwDMY1WVFunfseYb8kjK1csAzFuHU9qkA==";
					break;
				case "TEST":
					this.pythonServicesFunctionUrl = "https://mysynchpythonservices-functiontest.azurewebsites.net/api/TrendsAndTargets?code=p2Yqew_UybqU9oJGR7UZyLHlBTKKzRgGXwcSYf7EL77NAzFuvfBsQQ==";
					break;
				case "DEV":
					this.pythonServicesFunctionUrl = "https://mysynchpythonservices-functiondev.azurewebsites.net/api/TrendsAndTargets?code=87GKDcOVbLznlKvLc1SKlKmmJNbrlEKAJNoF_uGfCcQBAzFuXNc_-A==";
					break;
				default:  
					this.pythonServicesFunctionUrl = "https://mysynchpythonservices-functionstage.azurewebsites.net/api/TrendsAndTargets?code=sp6UN6KBWlvDXd-RjurwTjwDMY1WVFunfseYb8kjK1csAzFuHU9qkA==";
					//this.pythonServicesFunctionUrl = "https://mysynchpythonservices-functionprod.azurewebsites.net/api/TrendsAndTargets?code=od3EFBmOYwbjz8RM0nRYt5s0Fzfqw-WNhe3PmWQ8p-ovAzFufcnjSQ==";
					break; 
			}
		}

		private checkPermissions = () => {
			this.canViewPage = false;

			if (!_.isUndefined(this.currentActiveFarm) && !_.isNull(this.currentActiveFarm) && !_.isEmpty(this.currentActiveFarm)) {
				var herds = _.get(this.currentActiveFarm, 'herds', []);
				if (!_.isEmpty(herds)) {
					var hasHerdWithDC305 = _.any(herds, { herdMgmtSoftware: "DC305" });
					if (!hasHerdWithDC305) {
						this.MSF.loadPage("User");
					}
				}
			}

			if (_.isEqual(_.get(this.currentActiveFarm, 'allowTrendsAndTargets'), true)) {
				this.canViewPage = true;
			}
			console.log("## ---- checking permissions                                 ---- ##");
			//                                                                       .---- ##");

			this.hasJournalUpdatePermission   = this.viewAuth.hasPermission(this.mySynchEnumSvc.getMySynchEnumeration('Permission',this.journalUpdatePermissionCode));
		};
		
		private toggleShowJEs() {
			this.showingJEs = !this.showingJEs;
		};
		
		private journalRows(lineItem: any) {
                var id				= _.get(lineItem, 'id');
                var herdId			= _.get(lineItem, 'herdId');
                var date			= _.get(lineItem, 'date');
                var category		= _.get(lineItem, 'category');
                var categoryName	= _.get(_.find(this.MSF.lists.journalCategory, {code: category}), 'name');
                var description		= _.get(lineItem, 'description', '');
                var localDate		= moment(date).subtract(moment(date).utcOffset(), 'minutes');

				return {
                	id:				id,
                	herdId:			herdId,
					date:			date,
					category:		category,
					categoryName:	categoryName,
					description:	description,
					count:			1 * 0.0001,					// TODO: gather counts per period, or same date, or something
					localDate:	localDate.format(this.ymd),
					displayDate:	localDate.format(this.dateFormat),
					displayDateYY:	localDate.format(this.dateFormat) // had only YY in original code
				};
			}
		// Function to fetch and filter journal items for display in a table
		// Now accepts chart's start and end dates for filtering
		private filterJournalItemsForDisplay(chartFromDate, chartToDate) {
			
			
			// Use the chart's first and last dates for API call
			var fromDate    = chartFromDate;
			var toDate      = chartToDate;
			
			this.journalItems = this.journalItems.filter(item => {
									let itemDate = moment.utc(item.date);
									return itemDate >= moment.utc(fromDate) && itemDate <= moment.utc(toDate);
								});

		}

		private initializeChartSpecSignalValue(chartSpec:any,signalName: string, value: any) {
			const signalIndex = _.findIndex(chartSpec.signals, { name: signalName });
			if (signalIndex !== -1) {
				_.set(chartSpec, 'signals[' + signalIndex + '].value', value);
			}
		}


		private buildJournalData() {
				
			console.log("## ---- getting Journals                                     ---- ##");
			this.perfMetricSvc.startTiming('Page:ThreeYearTrendsJournalData:Request');
			this.api.getJournalByHerd(this.herdId, this.performanceContext, 
				                     (err, data) => {
					this.perfMetricSvc.endTiming("page",'Page:ThreeYearTrendsJournalData:Request', this.performanceContext);
					if (err) {
						this.log.error('Error getting journal data: ' + err);
					}
						// Call the function to filter journal items with the determined chart date range
					this.journalData = data;
					
					//console.log("## ---- Journal Items: "+ this.journalItems.length + " items found.         ---- ##");

					this.journalItems = _.sortByOrder(_.map(this.journalData, (journalDataItem) => this.journalRows(journalDataItem)),'localDate', 'DESC');

						// Format dates to YYYY-MM-DD for API call
					this.filterJournalItemsForDisplay(
						this.minChartDate ? this.minChartDate.format(this.ymd) : null,
						this.maxChartDate ? this.maxChartDate.format(this.ymd) : null
					);	

				});
				 
		}
		private setMobileChartAdjustments(chartSpec?: any) {
			const legendX2SignalIndex = _.findIndex(chartSpec.signals, { name: "legendXPosition2" });
			if (legendX2SignalIndex !== -1) {
				_.set(chartSpec, 'signals[' + legendX2SignalIndex + '].update', "ceil(width/2) - 150" ); // 130
				
			}

			const legendJournalIconIndex = _.findIndex(chartSpec.marks, { name: "legend_journal_icon" });
			const legendJournalIconLabelIndex = _.findIndex(chartSpec.marks, { name: "legend_journal_icon_label" });
			if (legendJournalIconIndex !== -1 && legendJournalIconLabelIndex !== -1) {
				_.set(chartSpec, 'marks[' + legendJournalIconIndex + '].encode.update.x', { "signal": "legendXPosition2 + 200" });
				_.set(chartSpec, 'marks[' + legendJournalIconIndex + '].encode.update.y', { "value": -16 });
				
				_.set(chartSpec, 'marks[' + legendJournalIconLabelIndex + '].encode.update.x', { "signal": "legendXPosition2 + 220" });
				_.set(chartSpec, 'marks[' + legendJournalIconLabelIndex + '].encode.update.y', { "value": -8 });
			}
		}
		private buildAndEmbedReports() {
			// --- Gather chart and data from API
			this.chartSpec_lg = _.cloneDeep(this.originalPythonSpecWithData);

			// --- MySynch changes to be made in the Python code:
			this.chartSpec_lg = _.omit(this.chartSpec_lg, 'width');

			if(this.isMobile){	
			 	this.setMobileChartAdjustments(this.chartSpec_lg);
			}
			_.set(this.chartSpec_lg, 'usermeta.embedOptions.renderer', "svg");
			_.set(this.chartSpec_lg, 'usermeta.embedOptions.actions',         { source: false, compiled: false, editor: this.showVegaEditor });
			_.set(this.chartSpec_lg, 'usermeta.embedOptions.actions.tooltip', { theme: 'dark' });

			// Initialize signals based on current options

			this.initializeChartSpecSignalValue(this.chartSpec_lg, 'fertilityRate_signal', this.opt.fertilityRateSelected);
			this.initializeChartSpecSignalValue(this.chartSpec_lg, 'show_dots_signal', this.opt.show21dayDots);
			this.initializeChartSpecSignalValue(this.chartSpec_lg, 'show_journals_signal', this.opt.showJournalEntries);
			this.initializeChartSpecSignalValue(this.chartSpec_lg, 'show_rha_signal', this.opt.showRhaLine);
			this.initializeChartSpecSignalValue(this.chartSpec_lg, 'show_new_year_signal', this.opt.showNewYear);
			this.initializeChartSpecSignalValue(this.chartSpec_lg, 'loess_weight_signal', parseFloat(this.opt.trendSensitivity));


			this.chartSpec_sm = _.cloneDeep(this.chartSpec_lg);

			// --- Small Charts
			var x_axis = _.findIndex(this.chartSpec_lg.axes, { name: 'x_axis' });
			var y_axis = _.findIndex(this.chartSpec_lg.axes, { name: 'y_axis' });
			
			_.set(this.chartSpec_sm, 'background', "#EBEBEB");
			_.set(this.chartSpec_sm, 'autosize',   "fit");

			_.set(this.chartSpec_sm, 'legends', []);
			_.set(this.chartSpec_sm, 'usermeta.embedOptions.actions', false);
			_.set(this.chartSpec_sm, 'axes[' + x_axis + '].labels',   false);
			_.set(this.chartSpec_sm, 'axes[' + x_axis + '].ticks',    false);
			_.set(this.chartSpec_sm, 'axes[' + y_axis + '].labels',   false);
			_.set(this.chartSpec_sm, 'axes[' + y_axis + '].ticks',    false);

			_.set(this.chartSpec_sm, 'height', { "signal": "width" });
			_.set(this.chartSpec_sm, 'data', _.get(this.chartSpec_lg, 'data', []));

			// testing 
			var width_index_sm  = _.findIndex(this.chartSpec_sm.signals, { name: 'width' });
			_.set(this.chartSpec_sm, 'signals[' + width_index_sm + '].init', "clamp(containerSize()[0],60,249)");
			_.set(this.chartSpec_sm, 'signals[' + width_index_sm + '].on[0].update', "clamp(containerSize()[0],60,249)");

			var dots_mark_index = _.findIndex(this.chartSpec_sm.marks, { name: 'mark_dots' });
			_.set(this.chartSpec_sm, 'marks[' + dots_mark_index + '].encode.update.tooltip', "");

			this.dataLact2    = _.cloneDeep(this.chartSpec_sm);
			this.dataLact1    = _.cloneDeep(this.chartSpec_sm);
			this.dataLactAll  = _.cloneDeep(this.chartSpec_sm);

			var wh_lact = _.findIndex(this.chartSpec_lg.signals, { name: 'lactation_signal' });
			_.set(this.dataLact1,   'signals[' + wh_lact + '].value', 1);
			_.set(this.dataLact2,   'signals[' + wh_lact + '].value', 2);
			_.set(this.dataLactAll, 'signals[' + wh_lact + '].value', 3);

			// --- Large Chart ---
			_.set(this.chartSpec_lg, 'height', { "signal": "width/1.8" });
			_.set(this.chartSpec_lg, 'signals[' + wh_lact + '].value', this.opt.lactSelected);
			
			// Add the cursor property to the journal icon mark
			var journalMarkIndex = _.findIndex(this.chartSpec_lg.marks, { name: 'mark_journal_icons' });
			if (journalMarkIndex !== -1) {
				_.set(this.chartSpec_lg, 'marks[' + journalMarkIndex + '].encode.update.cursor', { "signal": "show_journals_signal ? 'pointer' : 'default'" });
			}

			// removes tooltip from dots on large chart
			// var dots_mark_index = _.findIndex(this.chartSpec_lg.marks, { name: 'mark_dots' });
			// _.set(this.chartSpec_lg, 'marks[' + dots_mark_index + '].encode.update.tooltip', "");


			// testing
			var width_index_lg  = _.findIndex(this.chartSpec_lg.signals, { name: 'width' });
			_.set(this.chartSpec_lg, 'signals[' + width_index_lg + '].init',          "containerSize()[0] * 0.85");
			_.set(this.chartSpec_lg, 'signals[' + width_index_lg + '].on[0].update',  "containerSize()[0] * 0.85");

			// --- Determine chart's first and last dot dates for Journal Entry filtering ---
			var chartRawData = _.get(this.originalPythonSpecWithData, 'data[0].values', []); // Assuming main data is in data[0].values
			
			if (chartRawData.length > 0) {
				// Initialize with the first data point's date
				this.minChartDate = moment(chartRawData[0].date); 
				this.maxChartDate = moment(chartRawData[0].date);

				// Iterate to find the true min and max dates
				_.forEach(chartRawData, (d) => {
					var currentDate = moment(d.date); // Assuming 'date' is the field name for dates
					if (currentDate.isValid()) { // Ensure date is valid
						if (this.minChartDate === null || currentDate.isBefore(this.minChartDate)) {
							this.minChartDate = currentDate;
						}
						if (this.maxChartDate === null || currentDate.isAfter(this.maxChartDate)) {
							this.maxChartDate = currentDate;
						}
					}
				});
			}
                
              

		};


		private journalSignalListener = (name, journalIconItem) => {
			this.ngZone.run(() => {
				//console.log("## ---- journal_icon_click signal received                    ---- ##");
				if (!this.MSF.isNullish(journalIconItem)) {
					const journalIconJournals = _.get(journalIconItem, 'journals', []);
					let matchedJouralItems = [];

					_.forEach(journalIconJournals, (journalItem) => {
						let journalMatch = _.find(this.journalItems, { id: _.get(journalItem, "id") });
						if (!this.MSF.isNullish(journalMatch)) {
							matchedJouralItems.push(journalMatch);
						}
					});

					let firstJournal = _.get(matchedJouralItems, '[0]', null);
					let matchedSelectedJournal = _.find(this.selectedJournals, { id: _.get(firstJournal, "id") });

					if(_.isUndefined(matchedSelectedJournal)){

						this.selectedJournals = matchedJouralItems;
						if (this.selectedJournals.length > 0) {
							this.showingJEs = true;
						}
					}else{
						// Clicked the same journal again, so close the panel
						this.selectedJournals = [];
						this.showingJEs = false;
					}
				}
			});
		};

		private embedSelectedChart(spec, options) {
			// Clean up the existing view first
			if (this.currentLargeChartView && typeof this.currentLargeChartView.finalize === 'function') {
				console.log("Cleaning up existing large chart view before embedding new one");
				this.cleanupVegaView(this.currentLargeChartView, '#visSelected');
				this.currentLargeChartView = null;
			}
			vegaEmbed('#visSelected', spec, options).then((result) => {
				const view = result.view;
				// Track the current view
				this.currentLargeChartView = view;

				var show21dayDotsSignal = _.get(view,'_signals.show_dots_signal') as any;
				setTimeout(() => {
					console.log("## ---- show_dots_signal: " + show21dayDotsSignal.value + "               ---- ##");
				}, 3000);
				this.currentLargeChartView.addSignalListener('show_dots_signal', (name, value) => {
					console.log(`Existing signal ${name} changed to:`, value);
					 const showDotsSignalValue = !!value; // normalize
					 this.opt.show21dayDots = showDotsSignalValue;  // Angular state follows Vega
				});
				
				// Add journal icon click listener
				var journalIconClickSignal  = _.get(view,'_signals.journal_icon_click');
				// If the signal exists, register the listener
				if (!this.MSF.isNullish(journalIconClickSignal)) {
					// Register new listener
					view.addSignalListener('journal_icon_click', this.journalSignalListener);	
				}				
			}).catch(function(error) {
				console.error("Error embedding large chart:", error);
			});
		};

		private loadReports() {
		
			return new Promise<void>((resolve, reject) => {
				this.perfMetricSvc.startTiming('Page:ThreeYearTrendsPageData:Request');
				this.api.post(this.pythonServicesFunctionUrl,{},JSON.stringify({HerdId: this.herdId}), (err,result) => {
					this.perfMetricSvc.endTiming("page",'Page:ThreeYearTrendsPageData:Request', this.performanceContext);
					this.perfMetricSvc.startTiming('Page:ThreeYearTrendsPage:Build');
					this.originalPythonSpecWithData = result;
					this.buildAndEmbedReports();
					this.buildJournalData();
				    // Embed the charts
					const embed_small = { width: 200,  // actions: false, //padding: 20,
										config: {
											actions: false, 
											legend: [], 
											axis: {labels: false, ticks: false},
											lactation_signal: {value: 3},
										} as Config
									  } as EmbedOptions;
					const embed_large = { actions: false, tooltip: { theme: 'dark' } } as EmbedOptions; 

					// can be used for debug purposes.
					const showError = (el, error) => {
						el.innerHTML = ('<div class="error">'
							+ '<p>JavaScript Error: ' + error.message + '</p>'
							+ "<p>This usually means there's a typo in your chart specification. "
							+ "See the javascript console for the full traceback.</p>"
							+ '</div>');
				
						throw error;
					}
					// // Embed the charts
					
					// this.test_chartSpec_lg = _.cloneDeep(

					// // --- Add a Spec-on-the-fly for testing ---
					// //*

					// //* /


					// );       
					
					// Remove Journal Entries & disable tooltips for small chart specs
					const smallChartSpecs = [this.dataLactAll, this.dataLact1, this.dataLact2];
					const removedMarks = ['mark_journal_icons', 'legend_journal_icon','legend_journal_icon_label'];
					smallChartSpecs.forEach(spec => {
						if (!this.MSF.isNullish(spec) && !this.MSF.isNullish(_.get(spec,"marks")) && _.isArray(_.get(spec,"marks")) ) {
							spec.marks = spec.marks.filter(mark => !_.includes(removedMarks, mark.name));
						}
					});            

					// Make sure the large chart spec's "marks" name: mark_normal_region is first in the array so it is rendered below everything else
					if (!this.MSF.isNullish(this.chartSpec_lg) && !this.MSF.isNullish(_.get(this.chartSpec_lg,"marks")) && _.isArray(_.get(this.chartSpec_lg,"marks")) ) {
						const normalRegionIndex = this.chartSpec_lg.marks.findIndex(mark => mark.name === 'mark_normal_region');
						if (normalRegionIndex > -1) {
							this.chartSpec_lg.marks.unshift(this.chartSpec_lg.marks.splice(normalRegionIndex, 1)[0]);
						}
					}   

					
					this.perfMetricSvc.endTiming("page",'Page:ThreeYearTrendsPage:Build', this.performanceContext);
					
					vegaEmbed('#visLact1',    this.dataLact1,     embed_small).then((result) => { this.sm_chart_lactation1_view = result.view; })
					vegaEmbed('#visLact2',    this.dataLact2,     embed_small).then((result) => { this.sm_chart_lactation2_view = result.view; })
					vegaEmbed('#visLactAll',  this.dataLactAll,   embed_small).then((result) => { this.sm_chart_lactation_all_view = result.view; })
					this.embedSelectedChart(this.chartSpec_lg, embed_large);
							
					console.log("## ---- vegaEmbed is complete                              ---- ##");
					this.loading = false;
					resolve();
				});
			});
		};

		private cleanupVegaView(view, containerSelector) {
			if (!view) return;
			
			try {
				// 1. Remove all signal listeners - get all signal names from the view
				if (view._runtime && view._runtime.signals) {
					Object.keys(view._runtime.signals).forEach(signalName => {
						try {
							// Remove all listeners for this signal
							view.removeSignalListener(signalName, () => {});
						} catch (e) {
							// Signal listener might not exist, continue
							console.warn(`Error removing signal listener for ${signalName}:`, e);
						}
					});
				}
				
				// 2. Remove specific signal listeners you know about
				try {
					view.removeSignalListener('journal_icon_click', this.journalSignalListener);
				} catch (e) {
					// Listener might not exist
					console.warn('Error removing journal_icon_click signal listener:', e);
				}
				
				// 3. Remove event listeners if they exist
				if (view.removeEventListener) {
					['click', 'mouseover', 'mouseout', 'mousemove', 'touchstart', 'touchend'].forEach(event => {
						try {
							view.removeEventListener(event, () => {});
						} catch (e) {
							// Event listener might not exist, continue
							console.warn(`Error removing event listener for ${event}:`, e);
						}
					});
				}
				
				// 4. Finalize the view (this should clean up internal references)
				view.finalize();
				
				// 5. Clean up the DOM container thoroughly
				if (containerSelector) {
					const container = document.querySelector(containerSelector);
					if (container) {
						// First, remove all SVG elements specifically
						const svgElements = container.querySelectorAll('svg');
						svgElements.forEach(svg => {
							// Clone and replace to remove all event listeners
							const newSvg = svg.cloneNode(false); // shallow clone without children
							svg.parentNode.replaceChild(newSvg, svg);
							newSvg.remove();
						});
						
						// Then clear everything else
						container.innerHTML = '';
					}
				}
				
			} catch (e) {
				console.warn(`Error cleaning up Vega view for ${containerSelector}:`, e);
			}
		}

		private updateChartSignals(signalName, signalValue) {
			if (!this.MSF.isNullish(this.currentLargeChartView) && !this.MSF.isNullish(_.get(this.currentLargeChartView,'signal'))) {
				this.currentLargeChartView.signal(signalName, signalValue).runAsync()
			};
			if(!this.MSF.isNullish(this.sm_chart_lactation1_view) && !this.MSF.isNullish(_.get(this.sm_chart_lactation1_view,'signal'))){
				this.sm_chart_lactation1_view.signal(signalName, signalValue).runAsync()
			};
			if(!this.MSF.isNullish(this.sm_chart_lactation2_view) && !this.MSF.isNullish(_.get(this.sm_chart_lactation2_view,'signal'))){
				this.sm_chart_lactation2_view.signal(signalName, signalValue).runAsync()
			};
			if(!this.MSF.isNullish(this.sm_chart_lactation_all_view) && !this.MSF.isNullish(_.get(this.sm_chart_lactation_all_view,'signal'))){
				this.sm_chart_lactation_all_view.signal(signalName, signalValue).runAsync()
			};
		};
		private updateChartSignal(chartIdentifier, signalName, signalValue) {
			let targetView = null;
			switch(chartIdentifier) {
				case 'large':
					targetView = this.currentLargeChartView;
					break;
				case 'lact1':
					targetView = this.sm_chart_lactation1_view;
					break;
				case 'lact2':
					targetView = this.sm_chart_lactation2_view;
					break;
				case 'lactAll':
					targetView = this.sm_chart_lactation_all_view;
					break;
				default:
					console.warn(`Unknown chart identifier: ${chartIdentifier}`);
					return;
			}
			if (!this.MSF.isNullish(targetView) && !this.MSF.isNullish(_.get(targetView,'signal'))) {
				targetView.signal(signalName, signalValue).runAsync()
			};
		};

		closeJEs() {
			this.selectedJournals = [];
			this.showingJEs = false;
		}
			
		

		onChartOptionChange(signalName, newSignalValue) {
			// console.log('--- onChartOptionChange (signal) ---');
			// console.log('signalName       :', signalName);
			// console.log('newSignalValue   :', newSignalValue);
			this.updateChartSignals(signalName, newSignalValue);

			if(_.isEqual(signalName,"show_journals_signal") && _.isEqual(newSignalValue,false)){
				this.closeJEs(); // Hide Journal Entries when toggling off
			}
		}

	
		lactationOnChange(lactNum, evnt) {
			evnt.preventDefault();
			this.opt.lactSelected = lactNum;

			this.opt.lactSelectedDesc = (this.opt.lactSelected==1 ? 'Lactation 1'   :
									(this.opt.lactSelected==2 ? 'Lactation 2+'  :
									(this.opt.lactSelected==3 ? 'All Lactations' : null)));
			
			this.updateChartSignal('large', 'lactation_signal', this.opt.lactSelected);

			console.log("## ---- Changed lactation via button press, to "+this.opt.lactSelected+"                          ---- ##");
		};

			// --- Journal Entry Navigation Functions ---
		showAddNewJournalEntry() {
			this.MSF.loadPage('NewJournal', { cameFrom: 'TrendsAndTargets' });
		};

		showViewEditJournalEntry(row) {
			this.MSF.loadPage('JournalEdit', { id: row.id, cameFrom: 'TrendsAndTargets' });
		};

		

		
            
			

            

			
			

            
    
    

}